import React, { FC } from 'react'
import EobList from './EobList'
import EobDetail from './EobDetail'
import { ExplanationOfBenefitBundle } from '../../../../types/FHIRTypes/Bundle'

type EobsProps = {
  eobData: ExplanationOfBenefitBundle;
  eobDetailId: string | undefined;
  page: string | undefined;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const Eobs: FC<EobsProps> = ({ eobData, eobDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {
  return (
    <div>
      <section>
        {
          eobDetailId && page === 'ExplanationOfBenefit'
            ? (
              <EobDetail
                eobDetailId={eobDetailId}
              />
            )
            : (
              <EobList
                eobData={eobData}
                handleChangePage={handleChangePage}
                isFetching={isFetching}
                totalPages={totalPages}
                currentPage={currentPage}
              />
            )
        }
      </section>
    </div>
  )
}
export default Eobs